import type { RouteRecordRaw } from "vue-router"

import type { Permission } from "@/types"
import { FunctionalRole } from "@/graphql/types"

export const requiredKibigRoles = <Permission[]>[
  FunctionalRole.BaykibigExport,
  "employment:list",
  "employment:view",
  "employee:list",
  "employee:view",
  "child:list",
  "child:view",
  "commune:list",
  "commune:view",
  "contract:view",
  "booking:view",
]

export const requiredIdevRoles = <Permission[]>[
  FunctionalRole.ChildAndYouthServicesExport,
  "institution:view",
  "organization:view",
  "commune:view",
  "appointment:list",
  "appointment:view",
  "child:list",
  "child:view",
  "contract:view",
  "group:list",
  "group:view",
  "booking:view",
  "employee:list",
  "employee:view",
  "employment:view",
  "qualification:view",
]

const exportRoutes: Array<RouteRecordRaw> = [
  {
    path: "/export/kibigweb",
    name: "KibigWebExport",
    meta: {
      requiresInstitutionContext: true,
      requiredRoles: requiredKibigRoles,
    },
    component: () => import("./KibigWeb.vue"),
  },
  {
    path: "/export/idev",
    name: "ChildAndYouthServicesExport",
    meta: {
      requiresInstitutionContext: true,
      requiredRoles: requiredIdevRoles,
    },
    component: () => import("./ChildAndYouthServices.vue"),
  },
]

export default exportRoutes
